import { render, staticRenderFns } from "./TotalTargetSpecial.vue?vue&type=template&id=45d75ab1"
import script from "./TotalTargetSpecial.vue?vue&type=script&lang=js"
export * from "./TotalTargetSpecial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports